<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <customer-field slot="ac_custname" :label="customLabel.ac_custname || '客户名称'" v-model="form.main.ac_custname" @select="onSelectCustomer" />
        <combo-search-box
          slot="ac_industry"
          :label="customLabel.ac_industry || '行业类型'"
          placeholder="请选择或输入行业类型"
          v-model="form.main.ac_industry"
          url="/api/document/industry/getCombo"
          ref="combo"
        />
        <div class="weui-cell" slot="ac_contact">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ac_contact || "联系人"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ac_contact"
              placeholder="请输入联系人"
            />
          </div>
        </div>
        <div class="weui-cell" slot="ac_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ac_tel || "联系电话"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.ac_tel"
              placeholder="请输入联系电话"
            />
          </div>
        </div>
        <agent-search-box
          slot="ac_agentname"
         :label="customLabel.ac_agentname || '代理商名称'"
          placeholder="请输入或选择代理商名称"
          v-model="form.main.ac_agentname"
          @select="onSelectAgent"
          @onchange="agentChange"
          @blur="agentBlur"
        />
        <div class="weui-cell" slot="ac_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ac_remark || "备注"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ac_remark"
            />
          </div>
        </div>
      </custom-layout>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import AgentSearchBox from "@/components/field/AgentSearchBox.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    CustomerField,
    ComboSearchBox,
    AgentSearchBox
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/agent/agentcust",
      codeField: "ac_code",
      statusField: "ac_statuscode",
      caller: "AgentCust",
      xtype: "agent-agentcust-formpanel",
      form: {
        main: {},
      }
    };
  },
  methods: {
    onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
      main.ac_custid = selection.id;
      main.ac_custcode = selection.cu_code;
      main.ac_contact = selection.cc_name;
      main.ac_tel = selection.cc_tel;
    },
    onSelectAgent(selection) {
      var me = this,
        main = me.form.main;
      main.ac_agentname = selection.cu_name;
      main.ac_agentid = selection.id;
      main.ac_agentcode = selection.cu_code;
    },
    agentChange() {
      var me = this,
        main = me.form.main;
      main.ac_agentid = null;
      main.ac_agentcode = null;
    },
    agentBlur() {
      var me = this,
        main = me.form.main;
      if(!main.ac_agentid) {
        main.ac_agentname = null
      }
    },
    ac_industry_save(ac_industry){
      var me = this
      let combo = me.$refs.combo.data,
        save = combo.some(item => { return item.value == ac_industry })
      if(!save) {
        me.$ajax({
          url: '/api/document/industry/save',
          method: 'POST',
          jsonData: {
            in_name: ac_industry,
            id: 0
          }
        }).then()
      }
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.ac_custname) {
        me.$weui.topTips("请选择客户", 2000);
      } else if (!main.ac_agentname) {
        me.$weui.topTips("请填写或选择代理商", 2000);
      } else {
        me.form.main.ac_industry && me.ac_industry_save(me.form.main.ac_industry)
        me.p_save();
      }
    },
  }
}
</script>